"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = exports.checkers = void 0;
var _be = require("./be");
var _de = require("./de");
var _dk = require("./dk");
var _es = require("./es");
var _fr = require("./fr");
var _gb = require("./gb");
var _it = require("./it");
var _nl = require("./nl");
var _pt = require("./pt");
var _se = require("./se");
var labels = exports.labels = {
  BE: 'Numéro d’Entreprise / Ondernemingsnummer',
  DE: 'HRB',
  DK: 'CVR-nummer',
  ES: 'NIF',
  FR: 'SIRET',
  IT: 'P. IVA',
  NL: 'KvK-nummer',
  PT: 'NIF',
  SE: 'Organisationsnummer',
  UK: 'Unique Taxpayer Reference / Company Registration Number'
};
var checkers = exports.checkers = {
  BE: _be.beCompanyNumberChecker,
  DE: _de.deCompanyNumberChecker,
  DK: _dk.dkCompanyNumberChecker,
  ES: _es.esCompanyNumberChecker,
  FR: _fr.frCompanyNumberChecker,
  IT: _it.itCompanyNumberChecker,
  NL: _nl.nlCompanyNumberChecker,
  PT: _pt.ptCompanyNumberChecker,
  SE: _se.seCompanyNumberChecker,
  UK: _gb.gbCompanyNumberChecker
};